const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.?)+[a-zA-Z]{2,}))$/;
function isValidEmail(value) {
  return EMAIL_REGEX.exec(value) !== null;
}

export { isValidEmail as default };
//# sourceMappingURL=email.mjs.map
